<template>
    <div class="ip-blacklist-page">
        <!-- 查询筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-lock"></i>
                    <span>IP黑名单</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">筛选条件</span>
                </div>
            </div>
            <el-form :inline="true" :model="queryParams" class="filter-form" ref="queryForm">
                <el-form-item label="IP地址">
                    <el-input clearable v-model="queryParams.ipAddress" placeholder="请输入IP地址" style="width: 220px"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 表格卡片 -->
        <el-card shadow="always" class="table-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <span>数据列表</span>
                    <span class="total-badge">共 <b>{{ total }}</b> 条</span>
                </div>
                <div class="card-header-right">
                    <el-button type="danger" icon="el-icon-plus" @click="handleAdd">新增封禁</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                stripe
                v-loading="loading"
                element-loading-text="加载中..."
                style="width: 100%">
                <el-table-column type="index" label="序号" width="80" align="center"/>
                <el-table-column prop="ipAddress" label="IP地址" width="160" align="center"/>
                <el-table-column prop="ipRegion" label="归属地" min-width="160" align="center" show-overflow-tooltip/>
                <el-table-column label="来源" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.banSource === 1" type="warning" effect="plain">自动</el-tag>
                        <el-tag v-else type="info" effect="plain">手动</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="reason" label="封禁原因" min-width="200" align="center" show-overflow-tooltip/>
                <el-table-column prop="createTime" label="封禁时间" width="180" align="center"/>
                <el-table-column label="操作" width="100" align="center" fixed="right">
                    <template slot-scope="scope">
                        <div class="action-btns">
                            <el-button type="danger" size="mini" icon="el-icon-unlock" @click="handleUnblock(scope.row)">解封</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrapper" v-if="total > 0">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="queryParams.pageNum"
                    :page-size="queryParams.pageSize"
                    :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!-- 新增封禁对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            title="新增IP封禁"
            :visible.sync="dialogVisible"
            width="520px"
            class="ip-blacklist-dialog"
            @closed="resetForm">
            <el-form :model="form" :rules="rules" ref="form" label-width="90px">
                <el-form-item label="IP地址" prop="ipAddress">
                    <el-input v-model="form.ipAddress" placeholder="请输入要封禁的IPv4/IPv6地址" clearable/>
                </el-form-item>
                <el-form-item label="封禁原因" prop="reason">
                    <el-input
                        v-model="form.reason"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入封禁原因（选填）"
                        maxlength="255"
                        show-word-limit
                    />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { reqIpBlacklistPage, reqIpBlacklistAdd, reqIpBlacklistDelete } from '@/api/system/ipBlacklist'

export default {
    name: 'IpBlacklist',
    data() {
        return {
            loading: false,
            submitLoading: false,
            tableData: [],
            total: 0,
            queryParams: {
                pageNum: 1,
                pageSize: 20,
                ipAddress: undefined
            },
            dialogVisible: false,
            form: {
                ipAddress: undefined,
                reason: undefined
            },
            rules: {
                ipAddress: [
                    { required: true, message: '请输入IP地址', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.load()
    },
    methods: {
        /** 加载数据 */
        async load() {
            this.loading = true
            const params = {}
            for (const key in this.queryParams) {
                if (this.queryParams[key] !== undefined && this.queryParams[key] !== '') {
                    params[key] = this.queryParams[key]
                }
            }
            try {
                const data = await reqIpBlacklistPage(params)
                this.tableData = data.records || []
                this.total = data.total || 0
            } catch (e) {
                console.error('加载IP黑名单失败:', e)
            } finally {
                this.loading = false
            }
        },

        /** 查询 */
        handleSearch() {
            this.queryParams.pageNum = 1
            this.load()
        },

        /** 重置 */
        handleReset() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 20,
                ipAddress: undefined
            }
            this.load()
        },

        /** 分页大小变化 */
        handleSizeChange(val) {
            this.queryParams.pageSize = val
            this.queryParams.pageNum = 1
            this.load()
        },

        /** 当前页变化 */
        handleCurrentChange(val) {
            this.queryParams.pageNum = val
            this.load()
        },

        /** 打开新增对话框 */
        handleAdd() {
            this.dialogVisible = true
        },

        /** 重置表单 */
        resetForm() {
            this.form = { ipAddress: undefined, reason: undefined }
            if (this.$refs.form) {
                this.$refs.form.clearValidate()
            }
        },

        /** 提交新增 */
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return
                this.submitLoading = true
                reqIpBlacklistAdd({
                    ipAddress: this.form.ipAddress,
                    reason: this.form.reason
                }).then(() => {
                    this.$message.success('封禁成功')
                    this.dialogVisible = false
                    this.load()
                }).catch(() => {}).finally(() => {
                    this.submitLoading = false
                })
            })
        },

        /** 解封 */
        handleUnblock(row) {
            this.$confirm(`确认解封 IP「${row.ipAddress}」吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                return reqIpBlacklistDelete(row.id)
            }).then(() => {
                this.$message.success('解封成功')
                this.load()
            }).catch(() => {})
        }
    }
}
</script>

<style scoped lang="scss">
.ip-blacklist-page {
    padding: 0;

    .filter-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 16px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .table-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 14px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-header-left {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                font-size: 18px;
                color: #409eff;
            }

            .header-sub {
                font-size: 13px;
                font-weight: 500;
                color: #909399;
            }

            .total-badge {
                font-size: 13px;
                font-weight: 400;
                color: #909399;
                margin-left: 8px;

                b {
                    color: #409eff;
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }

        .card-header-right {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }

    .filter-form {
        padding: 4px 0 0;

        ::v-deep .el-form-item {
            margin-bottom: 8px;
        }
    }

    .pagination-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .action-btns {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 6px;
        white-space: nowrap;

        .el-button + .el-button {
            margin-left: 0;
        }
    }

    ::v-deep .el-divider--vertical {
        height: 1.2em;
        margin: 0 4px;
    }

    ::v-deep .el-table {
        th {
            background: #fafafa;
            color: #606266;
            font-weight: 600;
            font-size: 13px;
        }

        td {
            font-size: 13px;
        }

        .el-tag--plain {
            font-weight: 500;
        }
    }

    ::v-deep .el-dialog {
        border-radius: 6px;
        overflow: hidden;

        .el-dialog__header {
            padding: 16px 24px;
            border-bottom: 1px solid #ebeef5;

            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }

        .el-dialog__body {
            padding: 24px 30px 8px;
        }

        .el-dialog__footer {
            padding: 14px 30px;
            border-top: 1px solid #ebeef5;
        }
    }
}

@media screen and (max-width: 768px) {
    .ip-blacklist-page {
        .card-header {
            flex-wrap: wrap;
            gap: 8px;
        }

        .filter-form {
            ::v-deep .el-form--inline .el-form-item {
                display: block;
                width: 100%;
                margin-bottom: 12px;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content {
                width: 100%;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-select,
            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-input {
                width: 100% !important;
            }
        }

        ::v-deep .el-card__body {
            padding: 12px;
        }

        ::v-deep .el-table {
            overflow-x: auto;
            display: block;
        }

        ::v-deep .el-dialog {
            width: 95% !important;
            margin: 10px auto !important;
        }
    }
}
</style>
